import React from "react";
import { useMediaQuery } from 'react-responsive';
import WebAboutUsHeader from './Web';
import MobileAboutUsHeader from './Mobile';

const AboutUsHeader = () => {
    const isDesktop = useMediaQuery({ minWidth: 768 }); // 目前PC和平板的尺寸没有做区分
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <div>
            {isDesktop && <WebAboutUsHeader />}
            {isMobile && <MobileAboutUsHeader />}
        </div>
    );
};

export default AboutUsHeader;